<template>
  <div>
    <p class="body-1-bold">
      {{ i18n(translations.title) }}
    </p>

    <Form @submit="handleSubmit" />

    <RevInfoBlock
      :content="i18n(translations.infoBlockSubtitle)"
      :icon="IconInfo"
      :title="
        i18n(translations.infoBlockTitle, {
          count: lines.length,
        })
      "
      variant="info"
    >
      <ul class="my-16">
        <li
          v-for="(line, index) in lines"
          :key="index"
          class="body-2 list-disc"
        >
          {{ line }}
        </li>
      </ul>
    </RevInfoBlock>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevInfoBlock } from '@ds/components/InfoBlock'
import { IconInfo } from '@ds/icons/IconInfo'

import type { FormValues } from '../../ImportDrawer.types'
import Form from '../Form/Form.vue'

import translations from './ImportTrackingNumbers.translations'

const i18n = useI18n()

const emit = defineEmits(['submit'])

const lines = [
  i18n(translations.infoBlockLine1),
  i18n(translations.infoBlockLine2),
  i18n(translations.infoBlockLine3),
  i18n(translations.infoBlockLine4),
]
function handleSubmit(formValues: FormValues) {
  emit('submit', formValues)
}
</script>
